import Bowser from 'bowser';

let sessionAudit;

// Clase estándar con resto de proyectos
export default function getSessionAuditJSON(data) {
  try {
    if (!sessionAudit) {
      sessionAudit = new SessionAudit();
    }
    sessionAudit.registerSession(data);
    return JSON.stringify(sessionAudit);
  } catch (e) {
    console.error('SessionAuditJSON:', e);
    return '{}';
  }
}

class SessionAudit {
  constructor() {
    const UNKNOWN_DATA = 'Unknown';

    // En el constructor seteamos lo que entendemos que no variará entre las sesiones
    this.remoteUserAgent = navigator.userAgent;
    const bowser = Bowser.getParser(this.remoteUserAgent);

    this.remoteBrowser = `${bowser.getBrowserName() || UNKNOWN_DATA} ${bowser.getBrowserVersion() || ''}`;
    this.remoteOS = `${bowser.getOSName() || UNKNOWN_DATA} ${bowser.getOSVersion() || ''}`;
    this.remotelang = getLanguage();

    // Browser main language
    function getLanguage() {
      if (typeof navigator.language === 'string') {
        return navigator.language;
      }

      return getLanguages();
    }

    // Browser language array
    function getLanguages() {
      if (typeof navigator.languages === 'string') {
        return navigator.languages;
      }
      if (Array.isArray(navigator.languages)) {
        return navigator.languages.join(', ');
      }

      return UNKNOWN_DATA;
    }

    // Primordial actualizar cada registerSession (puede cambiar)
    this.registerSession = function ({ user, domain, group }) {
      this.ediwinUser = user;
      this.ediwinDomain = domain;
      this.ediwinGroup = group;
    };

    // Al lanzar el json aprovechamos para calcular la última parte
    this.toJSON = function () {
      return {
        ...this,
        innerResolution: `${screen.width}x${screen.height}`,
        outerResolution: `${screen.availWidth}x${screen.availHeight}`,
        // IMPORTANTE: A difererencia de la versión web, gracias al server de Node podemos calcular el remoteHost
        remoteHost: '', // Lo dejamos preparado para que se cumplimente con #registerSessionApiMiddleware.getRemoteIP
      };
    };
  }
}
